import axios from "axios";
import { environment } from "../config/enviroment";
import { msalInstance } from "..";
import { loginRequest } from "../config/authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const api = axios.create({
  baseURL: environment.API_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

// REQUEST INTERCEPTOR: obtiene un token fresco de MSAL antes de cada request
api.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount();
  if (!account) return config;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    sessionStorage.setItem("token", response.idToken);
    if (!config.headers) config.headers = {};
    config.headers["Authorization"] = `Bearer ${response.idToken}`;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ ...loginRequest, account });
    }
  }

  return config;
});

// RESPONSE INTERCEPTOR: maneja 401 con un reintento de refresco forzado
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const account = msalInstance.getActiveAccount();

      if (account) {
        try {
          const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account,
            forceRefresh: true,
          });
          sessionStorage.setItem("token", response.idToken);
          if (!originalRequest.headers) originalRequest.headers = {};
          originalRequest.headers["Authorization"] = `Bearer ${response.idToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          if (refreshError instanceof InteractionRequiredAuthError) {
            sessionStorage.clear();
            localStorage.clear();
            await msalInstance.acquireTokenRedirect({ ...loginRequest, account });
          }
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
